import { t } from '@lingui/core/macro';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import { InlineTextProps } from '@/design_system/Typography/InlineText/InlineText';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

import VATNotApplicableWarning from '../VATNotApplicableWarning/VATNotApplicableWarning';

const WorkshopPriceLabel = ({
  hideLabel,
  noVATApplied,
  size,
  weight,
  color = 'secondary',
  justifyContent,
  workshopName,
  isTotalLabel,
  hideWarning,
}: {
  hideLabel?: boolean;
  noVATApplied?: boolean;
  size?: InlineTextProps['size'];
  weight?: InlineTextProps['weight'];
  color?: InlineTextProps['color'];
  justifyContent?: 'end';
  workshopName?: string;
  isTotalLabel?: boolean;
  hideWarning?: boolean;
}) => {
  const { view: requestView, iam } = useRequestContext();

  const showWorkshopPriceAmountBeforeTaxes = requestView.workshopPrice.showAmountBeforeTaxes;
  const showNoVATWarning = !showWorkshopPriceAmountBeforeTaxes && noVATApplied;

  const label = showWorkshopPriceAmountBeforeTaxes
    ? `(${t({ id: '_general.excl-vat', message: 'excl. VAT' })})`
    : `(${t({ id: '_general.incl-vat', message: 'incl. VAT' })})`;

  const totalLabel = iam.hasOnlyWorkshopScopeOnRequest
    ? t({
        id: 'request-context.total-cost.workshop',
        message: 'Total price',
      })
    : t({
        id: 'request-context.total-cost',
        message: 'Total internal cost',
      });

  return (
    <Stack row gap=".4em" justifyContent={justifyContent}>
      <InlineText size={size} color={color} weight={weight}>
        {!hideLabel && (
          <>
            {isTotalLabel ? totalLabel : requestView.workshopPrice.labelWithoutVATInfo}
            {workshopName && !iam.hasOnlyWorkshopScopeOnRequest && ` - ${workshopName}`}{' '}
          </>
        )}
        {showNoVATWarning ? (
          <Stack className="color-warning-700" row style={{ display: 'inline-flex', gap: '.4em' }}>
            ({t({ id: '_general.excl-vat', message: 'excl. VAT' })})
            {!hideWarning && <VATNotApplicableWarning />}
          </Stack>
        ) : (
          <InlineText size={size} color={color} weight={weight}>
            {label}
          </InlineText>
        )}
      </InlineText>
    </Stack>
  );
};

export default WorkshopPriceLabel;
